var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#292929;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M224.129,219.484h-2.323v-2.323a1.161,1.161,0,1,0-2.323,0v2.323h-2.323a1.161,1.161,0,1,0,0,2.323h2.323v2.323a1.161,1.161,0,1,0,2.323,0v-2.323h2.323a1.161,1.161,0,1,0,0-2.323Z",
    transform: "translate(-184.645 -184.645)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M70.839,34.839h-7A27.9,27.9,0,0,0,37.161,8.158v-7a1.161,1.161,0,0,0-2.323,0v7A27.9,27.9,0,0,0,8.158,34.839h-7a1.161,1.161,0,0,0,0,2.323h7A27.9,27.9,0,0,0,34.839,63.842v7a1.161,1.161,0,0,0,2.323,0v-7A27.9,27.9,0,0,0,63.842,37.161h7a1.161,1.161,0,0,0,0-2.323ZM54.581,37.161h6.939A25.578,25.578,0,0,1,37.161,61.519V54.581a1.161,1.161,0,0,0-2.323,0v6.939A25.578,25.578,0,0,1,10.481,37.161h6.939a1.161,1.161,0,1,0,0-2.323H10.481A25.578,25.578,0,0,1,34.839,10.481v6.939a1.161,1.161,0,1,0,2.323,0V10.481A25.578,25.578,0,0,1,61.519,34.839H54.581a1.161,1.161,0,0,0,0,2.323Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M172.774,160a12.774,12.774,0,1,0,12.774,12.774A12.774,12.774,0,0,0,172.774,160Zm0,23.226a10.452,10.452,0,1,1,10.452-10.452A10.452,10.452,0,0,1,172.774,183.226Z",
    transform: "translate(-136.774 -136.774)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.c77878b93b5382528c942954d392589d.svg";
export { ForwardRef as ReactComponent };